import React from "react";
import Modal from "react-bootstrap/Modal";

function DeleteModal({ show, handleClose, handleDelete, message, title }) {

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <img src="/images/svg/delete-modal.svg" alt="icon" />
        <h5 className="my-3">{title || "Confirm Delete"}</h5>
        <p className="text-light mb-4 mx-2">{message}</p>
        <div className="d-flex align-items-center justify-content-center gap-3">
          <button onClick={handleClose} className="btn btn-outline-light">No</button>
          <button className="btn btn-primary" onClick={handleDelete}>Yes, Confirm</button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteModal;
